export default "__VITE_PUBLIC_ASSET__ba6cc504__"